import React from "react";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../../constants/ZoomAttendance.constants";
import { RangeFilterInput } from "../../common/RangeFilterInput";

export const AttendanceCountRangeFilterInput = (props) => {
  return (
    <RangeFilterInput
      {...props}
      fromKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_FROM}
      toKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_TO}
      fromPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.ZERO_PLACEHOLDER}
      toPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.MAX_PLACEHOLDER}
    />
  );
};

export const AttendanceRangeFilterInput = (props) => {
  return (
    <RangeFilterInput
      {...props}
      fromKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_FROM}
      toKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_TO}
      min={0}
      max={100}
      fromPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.ZERO_PLACEHOLDER}
      toPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.HUNDRED_PLACEHOLDER}
    />
  );
};
